import { Badge, BadgeProps } from '@mantine/core';

/**
 * IS-121/IS-125: the label marking a mandatory service. Kept in one place so
 * the editor and the rendered proposal cannot drift apart.
 */
export default function MandatoryMarker({
  shown,
  ...props
}: { shown?: boolean } & BadgeProps) {
  if (!shown) return null;

  return (
    <Badge component="span" size="xs" variant="light" color="blue" {...props}>
      Mandatory
    </Badge>
  );
}
